import { render } from "./CourseTrackItem.vue?vue&type=template&id=70573059&scoped=true&ts=true"
import script from "./CourseTrackItem.vue?vue&type=script&lang=ts"
export * from "./CourseTrackItem.vue?vue&type=script&lang=ts"

import "./CourseTrackItem.vue?vue&type=style&index=0&id=70573059&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70573059"]])

export default __exports__